
import * as z from "zod";
import { membershipTypes } from "./types";

const addressSchema = z.object({
  street1: z.string().min(1, "Street address is required"),
  street2: z.string().optional(),
  city: z.string().min(1, "City is required"),
  postalCode: z.string().min(1, "Postal code is required"),
});

const phoneSchema = z.object({
  areaCode: z.string().min(1, "Area code is required"),
  number: z.string().min(1, "Phone number is required"),
});

export const formSchema = z.object({
  applicationDate: z.date({
    required_error: "Application date is required",
  }),
  businessName: z.string().min(2, "Business name must be at least 2 characters"),
  email: z.string().email("Please enter a valid email address"),
  firstName: z.string().min(2, "First name must be at least 2 characters"),
  lastName: z.string().min(2, "Last name must be at least 2 characters"),
  address: addressSchema,
  businessAddress: addressSchema,
  mobileNumber: phoneSchema,
  businessNumber: phoneSchema,
  membershipType: z.enum(membershipTypes, {
    required_error: "Please select a membership type",
  }),
  currentPotatoArea: z.string().optional(),
  totalPotatoArea: z.string().optional(),
  plannedPotatoArea: z.string().optional(),
  termsAccepted: z.boolean().refine((val) => val === true, {
    message: "You must accept the terms to continue",
  }),
  signature: z.string().optional(),
  captchaToken: z.string().min(1, "Please complete the CAPTCHA verification"),
});
